import { Eye, X, Briefcase, GraduationCap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useStudentView } from '@/contexts/StudentViewContext';

export function StudentViewBanner() {
  const { isStudentView, exitStudentView, isRecruiterView, exitRecruiterView, isProfessorView, exitProfessorView } = useStudentView();

  if (!isStudentView && !isRecruiterView && !isProfessorView) return null;

  if (isProfessorView) {
    return (
      <div className="sticky top-0 z-50 w-full bg-primary text-primary-foreground border-b border-primary/50">
        <div className="container mx-auto px-4 py-2 flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 text-sm font-medium">
            <GraduationCap className="w-4 h-4 shrink-0" />
            <span>You are viewing Sellaris as a professor</span>
          </div>
          <Button
            size="sm"
            variant="ghost"
            onClick={exitProfessorView}
            className="h-7 gap-1.5 text-primary-foreground hover:bg-primary/20"
          >
            <X className="w-3.5 h-3.5" />
            Exit Professor View
          </Button>
        </div>
      </div>
    );
  }

  if (isRecruiterView) {
    return (
      <div className="sticky top-0 z-50 w-full bg-primary text-primary-foreground border-b border-primary/50">
        <div className="container mx-auto px-4 py-2 flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 text-sm font-medium">
            <Briefcase className="w-4 h-4 shrink-0" />
            <span>You are viewing Sellaris as a recruiter</span>
          </div>
          <Button
            size="sm"
            variant="ghost"
            onClick={exitRecruiterView}
            className="h-7 gap-1.5 text-primary-foreground hover:bg-primary/20"
          >
            <X className="w-3.5 h-3.5" />
            Exit Recruiter View
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="sticky top-0 z-50 w-full bg-primary text-primary-foreground border-b border-primary/50">
      <div className="container mx-auto px-4 py-2 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-sm font-medium">
          <Eye className="w-4 h-4 shrink-0" />
          <span>You are viewing Sellaris as a student</span>
        </div>
        <Button
          size="sm"
          variant="ghost"
          onClick={exitStudentView}
          className="h-7 gap-1.5 text-primary-foreground hover:bg-primary/20"
        >
          <X className="w-3.5 h-3.5" />
          Exit Student View
        </Button>
      </div>
    </div>
  );
}
